module.exports = __webpack_public_path__ + "img/poster_large.103a96cd.png";